import PcPersonalReport from './pc/report/index.vue'

const basePath = '/recruiting/personal'

export default {
  path: `${basePath}/report`,
  component: PcPersonalReport,
  meta: {
    titleI18nKey: 'personal.menu.myReport',
    isInclude: true,
    permission: ['COMPUTED_CANDIDATE_FINISHED_ASSESSMENT'],
    employeePermission: ['COMPUTED_EMPLOYEE_CAN_APPLY_JOB']
  }
}
